import { getHash } from '@/utils/Utils';
export enum FeatureFlag {
    POLYGONS,
    EXTRA_TILES,
}

const windowKey = 'vegkart-features';
const defaultFlags = new Set<FeatureFlag>([FeatureFlag.POLYGONS]);
const featureFlagsByName: Record<string, FeatureFlag> = {
    POLYGONS: FeatureFlag.POLYGONS,
    EXTRA_TILES: FeatureFlag.EXTRA_TILES,
};

export function initFlagsFromHash(): void {
    const hash = getHash(window.location.hash);
    const pattern = /features:([^/]+)?/;
    const featureFlagMatch = hash.match(pattern);
    const match = featureFlagMatch?.[1];
    if (match) {
        console.log(match.split(','), FeatureFlag);
        window[windowKey] = new Set<FeatureFlag>(
            match
                .split(',')
                .map(name => featureFlagsByName[name])
                .filter(v => v !== undefined)
        );
        console.log('Activated feature flags: ', flags());
    }
}
declare global {
    interface Window {
        [windowKey]: Set<FeatureFlag>;
    }
}
export function flags(): Set<FeatureFlag> {
    return window[windowKey] || defaultFlags;
}
